export { OptimizelyMockData } from './mockOptimizelyData';
export * from './client';
export * from './useOptimizelyVariation';
export * from './provePrefill';
export const PLAID_ADOPTION_FLAG = 'ece_plaid_adoption_test';
export const PLAID_ACTIVE_CONNECTION_FLAG = 'ece_plaid_active_connection';
export const PLAID_TRUE_MANDATORY_FLAG = 'plaid_true_mandatory';
export const SCC_BRUTE_FORCE_FALLBACK_FLAG = 'scc_brute_force_fallback';
export const FINCEN_PLACEMENT_FLAG = 'fincen_placement_flag';
